/* =========================================
   ORRA HAIRCARE — THEME JAVASCRIPT
   ========================================= */

document.addEventListener('DOMContentLoaded', function () {

  // ── CUSTOM CURSOR ────────────────────────
  const cursor = document.getElementById('cursor');
  const ring   = document.getElementById('ring');

  if (cursor && ring) {
    let mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
    });

    (function tick() {
      if (cursor) { cursor.style.left = mx + 'px'; cursor.style.top = my + 'px'; }
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      if (ring) { ring.style.left = rx + 'px'; ring.style.top = ry + 'px'; }
      requestAnimationFrame(tick);
    })();

    document.querySelectorAll('a, button').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        cursor.style.width  = '18px';
        cursor.style.height = '18px';
        ring.style.width    = '46px';
        ring.style.height   = '46px';
      });
      el.addEventListener('mouseleave', function () {
        cursor.style.width  = '8px';
        cursor.style.height = '8px';
        ring.style.width    = '30px';
        ring.style.height   = '30px';
      });
    });
  }

  // ── SCROLL REVEAL ────────────────────────
  var revealEls = document.querySelectorAll(
    '.phil-card, .product-card, .t-card, .ritual-step, .test-card'
  );

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity   = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.1 });

    revealEls.forEach(function (el) {
      el.style.opacity    = '0';
      el.style.transform  = 'translateY(18px)';
      el.style.transition = 'opacity .6s ease, transform .6s ease';
      obs.observe(el);
    });
  } else {
    // Fallback for older browsers
    revealEls.forEach(function (el) {
      el.style.opacity = '1';
    });
  }

  // ── PRODUCT IMAGE THUMBNAILS ─────────────
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('main-product-img');
      if (mainImg) mainImg.src = thumb.dataset.full;
      document.querySelectorAll('.product-thumb').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

  // ── AJAX ADD TO CART ─────────────────────
  document.querySelectorAll('.p-add[type="submit"], .add-to-cart-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var form = btn.closest('form');
      if (!form) return;
      e.preventDefault();

      var variantId = form.querySelector('[name="id"]');
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId.value, quantity: 1 })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = '✓ Added';
        btn.style.background    = 'var(--ink)';
        btn.style.color         = 'var(--white)';
        btn.style.borderColor   = 'var(--ink)';
        setTimeout(function () {
          btn.textContent      = originalText;
          btn.style.background = '';
          btn.style.color      = '';
          btn.style.borderColor = '';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = originalText; }, 2000);
      });
    });
  });

  // ── MOBILE NAV TOGGLE ────────────────────
  var navToggle = document.getElementById('nav-toggle');
  var navMenu   = document.querySelector('.nav-links');
  if (navToggle && navMenu) {
    navToggle.addEventListener('click', function () {
      navMenu.classList.toggle('open');
    });
  }

});
